/**
 * Django interop helpers.
 *
 * CSRF: Django sets a non-HttpOnly `csrftoken` cookie that JS reads and echoes
 * back in the `X-CSRFToken` header on mutating requests. This is the mechanism
 * the allauth headless browser client expects.
 */

function getCookie(name: string): string | null {
  if (!document.cookie) return null;
  for (const raw of document.cookie.split(";")) {
    const cookie = raw.trim();
    if (cookie.startsWith(name + "=")) {
      return decodeURIComponent(cookie.substring(name.length + 1));
    }
  }
  return null;
}

export function getCSRFToken(): string | null {
  return getCookie("csrftoken");
}
